import { useEffect, useState } from 'react';

/** False for `ms`, then true. `ms <= 0` is true from the first render. */
export function useDelayed(ms: number): boolean {
  const [ready, setReady] = useState(ms <= 0);
  useEffect(() => {
    if (ms <= 0) {
      setReady(true);
      return undefined;
    }
    const timer = setTimeout(() => setReady(true), ms);
    return () => clearTimeout(timer);
  }, [ms]);
  return ready;
}
